'use client';

import type { ButtonClickEvent } from '@hc-frontend/core-ui';
import { useEventBus, useTrackingContexts } from '@hc-frontend/core-ui';
import type { MouseEventHandler, ReactNode } from 'react';
import React from 'react';

import { useUccModalContext } from './modal-provider';

export function UccModalButtonTrigger({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const ref = useUccModalContext();
  const eventBus = useEventBus();
  const contexts = useTrackingContexts();

  const handleOpenModal: MouseEventHandler<HTMLButtonElement> = (event) => {
    ref?.current?.showModal();
    eventBus.publish<ButtonClickEvent>({
      id: 'connect-me-modal-trigger',
      topic: 'core.ui.button.click',
      source: event.currentTarget,
      contexts,
    });
  };

  return (
    <button type="button" onClick={handleOpenModal} className={className}>
      {children}
    </button>
  );
}
